import { render, staticRenderFns } from "./PurchaseHero.vue?vue&type=template&id=18d5f833&scoped=true&"
import script from "./PurchaseHero.vue?vue&type=script&lang=js&"
export * from "./PurchaseHero.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseHero.vue?vue&type=style&index=0&id=18d5f833&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d5f833",
  null
  
)

export default component.exports